<template>
  <WdsStack gap-custom="32px" class="tw-w-full">
    <WdsStack class="tw-w-3/5" direction-column gap-lg>
      <HireContractSummary :hire-id="hireId" />
      <HireInternalFields :hire-id="hireId" />
    </WdsStack>
    <WdsStack class="tw-w-2/5 tw-h-max tw-rounded" direction-column gap-md>
      <HireDocuments v-if="false" :hire-id="hireId" />
      <HireJobRequirements :hire-id="hireId" />
    </WdsStack>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsStack } from '@worksome/wds-components'
import HireJobRequirements from '@/components/Hire/HireJobRequirements.vue'
import HireContractSummary from '@/components/Hire/HireContractSummary.vue'
import HireInternalFields from '@/components/Hire/HireInternalFields.vue'
import HireDocuments from '@/components/Hire/HireDocuments.vue'

defineProps<{
  hireId: string
}>()
</script>

<style lang="scss"></style>
